import React from "react";
import Swal from "sweetalert2";
/** Components Import */
import CardWrap from "../../Components/Card_wrap";
/** Grid Import */
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

const Dialog = {
  Alert: (_message = "hello world.") => {
    Swal.fire(_message);
  },

  // Snack bar type options: "success", "error", "warning", "info", "question"
  // Snack bar position options: "top", "top-start", "top-end", "center", "center-start", "center-end",
  //     "bottom", "bottom-start", "bottom-end"
  // Snackbar: (
  // 	_type = "success",
  // 	_message = "success",
  // 	_time = 3000,
  // 	_position = "bottom-left"
  // ) => {
  // 	Swal.fire({
  // 		toast: true,
  // 		position: _position,
  // 		icon: _type,
  // 		title: _message,
  // 		showConfirmButton: false,
  // 		timer: _time,
  // 		timerProgressBar: true,
  // 	});
  // },

  // Progress bar open options: "ture" -> exec progressbar, "false" -> cancel progressbar
  ProgressBar: (_open) => {
    switch (_open) {
      case true:
        Swal.fire({
          title: "Loading...",
          html: "Processing...",
          timerProgressBar: true,
          allowOutsideClick: false,
          background:
            "#fff url(https://sweetalert2.github.io/#examplesimages/trees.png)",
          // 귀요미 고양이
          // backdrop: `
          //     rgba(0,0,123,0.4)
          //     url("https://sweetalert2.github.io/images/nyan-cat.gif")
          //     left top
          //     no-repeat
          // `,

          didOpen: () => {
            const swalContainers =
              document.getElementsByClassName("swal2-container ");

            for (const container of swalContainers) {
              container.style.zIndex = 9999;
            }
            Swal.showLoading();
          },
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
          }
        });
        break;
      case false:
        Swal.close();
        break;
    }
  },

  // Confirm confirmFunction options: exec confirm's event
  Confirm: (
    _title = "Confirm",
    _message = "Are you sure?",
    _buttonName = "확인",
    _confirmFunc = () => {},
    _cancelName = "Cancel",
    _type = "question"
  ) => {
    Swal.fire({
      title: _title,
      text: _message,
      icon: _type,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: _buttonName,
      cancelButtonText: _cancelName,
    }).then((result) => {
      if (result.isConfirmed) {
        _confirmFunc();
      }
    });
  },

  // Inputs type options: "text", "email", "url", "password", "textarea", "select", "radio"
  Inputs: async (
    _title = "Inputs",
    _inputName = "Input name",
    _type = "text",
    _inputOptions = {}
  ) => {
    let returnData = null;

    const ReturnInputOptions = () => {
      switch (_type) {
        case "select":
        case "radio":
          return _inputOptions;
        default:
          return null;
      }
    };

    await Swal.fire({
      title: _title,
      input: _type,
      inputLabel: _inputName,
      inputOptions: ReturnInputOptions(),
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        returnData = result.value;
      }
    });

    return returnData;
  },
};

export default Dialog;
